export default String.raw`
.homepage {
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  overflow: hidden;

  section {
    margin: 16px 0;
  }
}

@media screen and (min-width: 769px) and (max-width: 1439px) {
  .homepage {
    padding: 16px 0;
  }
}

@media screen and (max-width: 767px) {
  .homepage {
    padding: 16px 0;
  }
}
`